export enum BlockType {
  Header = 'HEADER',
  ImageGallery = 'IMAGE_GALLERY',
  Text = 'TEXT',
  Recruiter = 'RECRUITER',
  ProcedureExplainer = 'PROCEDURE_EXPLAINER',
  Application = 'APPLICATION'
}
